module.exports = __webpack_public_path__ + "static/media/learn_play.d8af78d5.svg";